export function toast(message) {
  window.alert(message)
}

export default toast;
